import { render, staticRenderFns } from "./Imagetransform.vue?vue&type=template&id=44f45bba&scoped=true"
import script from "./Imagetransform.vue?vue&type=script&lang=js"
export * from "./Imagetransform.vue?vue&type=script&lang=js"
import style0 from "./Imagetransform.vue?vue&type=style&index=0&id=44f45bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f45bba",
  null
  
)

export default component.exports